import { WSTableCellProps } from "@wingspanhq/fe-component-library";
import { PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";

export const getClientsCellProps = (
  requirements: PayeeRequirement[]
): WSTableCellProps | undefined => {
  const requirementsLength = requirements.length;

  // If there is only one requirement, don't put clients cell, it will display client name in the table
  if (requirementsLength > 1) {
    return {
      text: `${requirementsLength} clients`
    };
  }

  return undefined;
};
